import React from 'react';
import { motion } from 'framer-motion';
import { Search, FileText, Users, Trophy } from 'lucide-react';
const steps = [{
  icon: <Search className="w-5 h-5" data-id="element-88" />,
  title: 'Аналіз ситуації',
  desc: 'Детально вивчаємо вашу ситуацію та наявні документи. Визначаємо чіткі правові підстави для захисту.'
}, {
  icon: <FileText className="w-5 h-5" data-id="element-89" />,
  title: 'Підготовка документів',
  desc: 'Готуємо заяви, скарги, позови, клопотання, апеляції та інші необхідні процесуальні документи.'
}, {
  icon: <Users className="w-5 h-5" data-id="element-90" />,
  title: 'Представництво',
  desc: 'Захищаємо ваші інтереси у судах, ТЦК та СП, військових частинах та інших державних установах.'
}, {
  icon: <Trophy className="w-5 h-5" data-id="element-91" />,
  title: 'Реальний результат',
  desc: 'Допомагаємо правильно побудувати правову позицію та супроводжуємо справу до практичного вирішення.'
}];
export function HowWeWork() {
  return <section id="process" className="py-24 bg-white" data-id="element-92">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-93">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-94">
          <div className="lg:w-1/3" data-id="element-95">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight mb-6" data-id="element-96">
              Як ми працюємо
            </h2>
            <p className="text-lg text-slate-500 leading-relaxed mb-8" data-id="element-97">
              Якщо ситуація потребує чіткого правового аналізу та реального
              супроводу, ми беремо справу в роботу на всіх етапах.
            </p>
            <div className="p-6 bg-slate-50 rounded-2xl border border-slate-100" data-id="element-98">
              <p className="text-sm font-medium text-slate-700" data-id="element-99">
                "Ми не просто консультуємо — ми доводимо справу до кінця."
              </p>
            </div>
          </div>

          <div className="lg:w-2/3" data-id="element-100">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-101">
              {steps.map((step, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="relative p-6 rounded-3xl border border-slate-100 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-102">
                  <div className="flex items-center gap-4 mb-4" data-id="element-103">
                    <div className="w-10 h-10 rounded-full bg-slate-900 text-white flex items-center justify-center font-bold shadow-md" data-id="element-104">
                      {index + 1}
                    </div>
                    <h3 className="text-lg font-bold text-slate-900" data-id="element-105">
                      {step.title}
                    </h3>
                  </div>
                  <p className="text-slate-500 text-sm leading-relaxed" data-id="element-106">
                    {step.desc}
                  </p>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}